import PaginatedSearchResultMetadata, {PaginatedSearchResultMetadataDto} from "../../../search/PaginatedSearchResultMetadata"
import {PaymentTransactionElastic, PaymentTransactionElasticDto} from "./paymentTransactionElastic"

export type PaymentTransactionItemsResultDto = {
    paymentTransactionItems: PaymentTransactionElasticDto[]
} & PaginatedSearchResultMetadataDto

export default class PaymentTransactionItemsResult extends PaginatedSearchResultMetadata {
    data: PaymentTransactionItemsResultDto
    paymentTransactions: PaymentTransactionElastic[]

    constructor(dto: PaymentTransactionItemsResultDto) {
        super({
            PageSize: dto.PageSize,
            ActivePage: dto.ActivePage,
            TotalItemsCount: dto.TotalItemsCount,
        })
        this.data = dto
        this.paymentTransactions = dto.paymentTransactionItems?.map(sn => new PaymentTransactionElastic(sn)) || []
    }

    getItems(): Array<PaymentTransactionElasticDto> {
        return this.data.paymentTransactionItems ?? []
    }
}



// WEBPACK FOOTER //
// ./src/state/listing/payment-transactions/models/paymentTransactionItemsResult.ts